import React from 'react'
import { updateObject } from 'helpers/objectHelpers'
import FormInput from 'components/forms/bases/FormInput'

const YoutubeContent = ({
  value,
  value: {
    source,
  },
  onChange,
}) => {
  const handleChange = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  return (
    <FormInput
      label="youtube url"
      value={source}
      onChange={(val) => handleChange(val, 'source')}
    />
  )
}

YoutubeContent.propTypes = {}
YoutubeContent.defaultProps = {}

export default YoutubeContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/youtube/YoutubeContent.js